import { createSlice } from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

const persistConfig = {
  key: "authSlice",
  version: 1,
  storage,
  blacklist: [],
};

const initialState = {
  isLoggedIn: false,
  userDetail: null,
  businessDetailForm: null,
  token: null,
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    loggedIn: (state, data) => {
      state.isLoggedIn = true;
      state.userDetail = data.payload.user;
      state.token = data.payload.token;
    },

    userLogout: (state) => {
      state.isLoggedIn = false;
      state.userDetail = null;
      state.token = null;
      state.userId = null;
    },

    updateUserProfile: (state, data) => {
      state.userDetail = { ...state.userDetail, ...data.payload };
    },

    // updateBusinessForm: (state, action) => {
    //   const updates = action.payload;
    
    //   Object.keys(updates).forEach((key) => {
    //     if (state.businessDetailForm[key]) {
    //       // Merge into existing nested object
    //       state.businessDetailForm[key] = {
    //         ...state.businessDetailForm[key],
    //         ...updates[key],
    //       };
    //     } else {
    //       // Add new key if it doesn't exist
    //       state.businessDetailForm[key] = updates[key];
    //     }
    //   });
    // },

    updateBusinessForm: (state, data) => {
      state.businessDetailForm = { ...state.businessDetailForm, ...data.payload };
    },

    emptyBusinessForm: (state) => {
      state.businessDetailForm = null;
    },
  },
});

export const {
  loggedIn,
  userLogout,
  updateUserProfile,
  updateBusinessForm,
  emptyBusinessForm,
} = authSlice.actions;

export default persistReducer(persistConfig, authSlice.reducer);